import { ListEmptyState, StateMessage } from "@/ds";
import type { ListEmptyKind } from "@/ds";

import type { CargaEstadoProps } from "./types-carga-estado";

/** Valor do `data-variant` do vazio, que as telas e os testes leem. */
const VARIANTE_DO_VAZIO: Record<ListEmptyKind, string> = {
  "sem-registros": "empty",
  "sem-resultados-busca": "search",
  "sem-resultados-filtros": "filter",
};

export function CargaEstadoView({
  status,
  errorMessage,
  onRetry,
  isEmpty,
  emptyKind,
  emptyContent,
  onClearEmpty,
  ids,
}: CargaEstadoProps) {
  if (status === "forbidden") {
    return (
      <StateMessage
        variant="forbidden"
        title="Acesso não autorizado"
        description={errorMessage ?? undefined}
        testId={ids.forbidden}
      />
    );
  }

  if (status === "loading") {
    return (
      <StateMessage
        variant="loading"
        title="Carregando carga de trabalho..."
        testId={ids.loading}
      />
    );
  }

  if (status === "error") {
    return (
      <StateMessage
        variant="error"
        title="Não foi possível carregar a carga de trabalho"
        description={errorMessage ?? undefined}
        testId={ids.error}
        action={{ label: "Tentar novamente", onClick: onRetry, testId: ids.retry }}
      />
    );
  }

  if (!isEmpty) return null;

  return (
    <ListEmptyState
      noun="registro"
      gender="m"
      title={emptyContent.title}
      description={emptyContent.description}
      hasSearch={emptyKind === "sem-resultados-busca"}
      hasFilters={emptyKind === "sem-resultados-filtros"}
      onClear={onClearEmpty}
      testId={ids.empty}
      clearTestId={`${ids.empty}-clear`}
      data-variant={VARIANTE_DO_VAZIO[emptyKind]}
    />
  );
}
